window.GTM = (function () {
  return {
    pushEvent: function ({ name, payload }) {
      const eventData = payload ? { [name]: payload } : {};
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          event: name,
          ...eventData,
        });
      } else {
        console.error('dataLayer is not defined. Make sure GTM is properly initialized.');
      }
    },
  };
})();
